"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconFindContractor = function IconFindContractor(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M18.151 27.405c-3.48-5.768-2.733-13.373 2.245-18.35 5.857-5.858 15.355-5.858 21.213 0s5.858 15.355 0 21.213c-5.079 5.079-12.893 5.754-18.7 2.027l-9.622 9.622a2.21 2.21 0 0 1-2.997.117l-.127-.117-1.7-1.7a2.21 2.21 0 0 1-.117-2.997l.117-.127zm1.165 1.663-9.438 9.439a.21.21 0 0 0-.04.242l.04.054 1.699 1.7a.21.21 0 0 0 .242.039l.054-.04 9.413-9.412a15 15 0 0 1-1.97-2.022m20.879-18.599c-5.077-5.077-13.308-5.077-18.385 0s-5.077 13.308 0 18.385 13.308 5.077 18.385 0 5.077-13.308 0-18.385M26.27 11.703l.52.854a7.68 7.68 0 0 0-3.683 6.74l.012.283-.998.06a8.68 8.68 0 0 1 3.895-7.776z",
    clipRule: "evenodd"
  })));
};

export { IconFindContractor, IconFindContractor as default };
